import { Component, OnInit } from '@angular/core';
import {NotificationService} from "@progress/kendo-angular-notification";
import {FastLinkDataService} from "../fastlinkdataservice";
import {AuthService} from "@auth0/auth0-angular";

@Component({
  selector: 'app-fast-link-blue-print-updater',
  templateUrl: './fast-link-blue-print-updater.component.html',
  styleUrls: ['./fast-link-blue-print-updater.component.css']
})
export class FastLinkBluePrintUpdaterComponent implements OnInit {
  userName: string | undefined;

  constructor(private notificationService: NotificationService, private fastLinkDataService: FastLinkDataService, public auth: AuthService)  { }

  ngOnInit() {
    this.auth.user$.subscribe(
      (profile) => (this.userName = profile?.name)
    );
  }
  public Show(): void {
    this.notificationService.show({
      content: "The current fastlink configuration is now the BLUEPRINT",
      cssClass: "button-notification",
      animation: { type: "slide", duration: 400 },
      position: { horizontal: "center", vertical: "top" },
      type: { style: "success", icon: true },
      closable: true,
    });
  }

  private GetUser():string{
    if( this.userName)
      return this.userName;
    else
      return "NO-USER";
  }

  onActivate(event: any) {
    console.log('Update the FASTLINK BLUEPRINT: ');
    this.Show();
    this.fastLinkDataService.SentUpdateRequest(this.GetUser());
  }







}
